import React from "react";
import { Button } from "semantic-ui-react";
import { svgToLines } from "../utils";
import { type Line } from "./models";
import SigningCanvas from "./SigningCanvas";
import { hasDrawnProperSignature } from "./utils";

interface Props {
  initialSvg: string
  onSignClicked: (svg: string) => Promise<void>
  onLinesChanged?: (newLines: Line[]) => void
}

interface State {
  lines: Line[]
  error: boolean
  isLoading: boolean
}

export default class SigningCanvasWithSignButton extends React.Component<Props, State> {
  state: State = {
    lines: [],
    error: false,
    isLoading: false
  };

  svgRef = React.createRef<SVGSVGElement>();

  componentDidMount() {
    if (this.props.initialSvg) {
      this.setState({
        lines: svgToLines(this.props.initialSvg)
      });

      this.props.onLinesChanged?.(svgToLines(this.props.initialSvg));
    }
  }

  onLinesChanged = (newLines: Line[]) => {
    this.setState({ lines: newLines, error: false });
    this.props.onLinesChanged?.(newLines);
  };

  onReset = () => {
    this.setState({ lines: [] });
    this.props.onLinesChanged?.([]);
  };

  onSignClicked = async () => {
    if (!hasDrawnProperSignature(this.state.lines)) {
      this.setState({ error: true });
      return;
    }

    this.setState({ isLoading: true });
    try {
      await this.props.onSignClicked(this.svgRef.current.innerHTML);
    } catch {
      this.setState({ isLoading: false });
    }
  };

  public render(): JSX.Element {
    return <div className="margin-bottom">
      <SigningCanvas
        svgRef={this.svgRef}
        error={this.state.error}
        lines={this.state.lines}
        onLinesChanged={this.onLinesChanged}
      />
      <div className="margin-top-small flex">
        <div className="grow1">
          <a onClick={this.onReset}>clear</a>
        </div>
        <div className="margin-top">
          <Button
            loading={this.state.isLoading}
            disabled={this.state.isLoading}
            icon="right arrow"
            labelPosition="right"
            primary onClick={this.onSignClicked}
            content={RESX.ESign.SignNow}
          />
        </div>
      </div>
    </div>;
  }
}
